import styled from 'styled-components';

export const Wrapper = styled.div`
  box-shadow: 3px 4px 13px rgba(0, 0, 0, 0.19);
`;
